package one.healthium.log_food.ui.find_food

import one.healthium.profile.ui.food.models.FoodUiModel

data class FindFoodUiState(
    val loading: Boolean = false,
    val searchQuery: String = "",
    private val foodSuggestions: List<FoodUiModel>? = null,
    private val foods: List<FoodUiModel>? = null,
) {
    val uiData: List<Any>? = when {
        foods != null -> {
            if (foods.isEmpty()) {
                listOf(EmptyFindUiModel)
            } else {
                buildList {
                    addAll(foods)
                    add("© Open Food Facts contributors")
                }
            }
        }

        foodSuggestions != null -> foodSuggestions

        else -> null
    }
}

data object EmptyFindUiModel